import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetEigeneAuftraegeMutation } from '../../api/AuftragAPI';
import { formatToEuroDate } from '../../util/DateUtils';

export default function LandingPageKunde() {

    type myauftrag = {
        uid: string,
        art: string,
        status: string,
        auftraggeber: string,
        vorname_endkunde: string,
        name_endkunde: string,
        stadt_lieferadresse: string
        aktuellerTermin: Date,
        createDate: Date,
    }

    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [eigeneauftraegeAPI] = useGetEigeneAuftraegeMutation();
    const [auftraege, setAuftraege] = useState<myauftrag[]>([]);

    const lade = () => {

        eigeneauftraegeAPI().unwrap()
            .then((data) => setAuftraege(data));

    }

    useEffect(() => {
        lade();
    }, []);

    return (
        <>
            <div className="container">

                <div style={{ alignItems: "end", display: "flex", justifyContent: "end" }}>

                    <button onClick={() => navigate("/neuerauftrag")}
                        style={{ marginBottom: "20px", alignItems: "end" }}
                        className=' btn btn-outline-primary'
                    >
                        <i className='bi bi-plus'></i>&nbsp;Neuen Auftrag anlegen
                    </button>

                </div>

                <h3>{t('deTranslation.eigeneAuftraege.titel')}</h3>

                <p>
                    Anzahl {auftraege.length}
                </p>

                <table className="table">

                    <tr>
                        <th>Art</th>
                        <th>Status</th>
                        <th>Name</th>
                        <th>Lieferort</th>
                        <th>Termin</th>
                        <th>Erstellt am</th>
                        <th>Option</th>
                    </tr>

                    {auftraege.map((e) => <>
                        <tr key={e.uid}>
                            <td>{e.art}</td>
                            <td>{e.status}</td>
                            <td>{e.vorname_endkunde} {e.name_endkunde}</td>
                            <td>{e.stadt_lieferadresse}</td>
                            <td>{formatToEuroDate(e.aktuellerTermin)}</td>
                            <td>{formatToEuroDate(e.createDate)}</td>
                            <td><button className="btn btn-outline-secondary" onClick={() => navigate("eigeneauftraege/detail/" + e.uid)}><i style={{ cursor: "pointer", fontSize: "18pt" }} className="bi bi-info-circle-fill"></i></button></td>
                        </tr>
                    </>)}

                </table >

            </div>

        </>
    );
}
